module.exports = __webpack_public_path__ + "static/WorkSans-VariableFont_wght-b24396917a138794160b24ff04a71d80.ttf";